import type {PropsWithChildren} from 'react'
import {createContext, useContext, useMemo} from 'react'

interface BaseUrlContextState {
  baseUrl: string
}

const BaseUrlContext = createContext<BaseUrlContextState | null>(null)

export function BaseUrlContextProvider({children, baseUrl}: PropsWithChildren<BaseUrlContextState>) {
  const contextValue = useMemo<BaseUrlContextState>(() => ({baseUrl}), [baseUrl])
  return <BaseUrlContext.Provider value={contextValue}>{children}</BaseUrlContext.Provider>
}

export function useBaseUrl() {
  const context = useContext(BaseUrlContext)

  if (!context) {
    throw new Error('useBaseUrl must be used within a BaseUrlContextProvider.')
  }

  return context.baseUrl
}

try{ BaseUrlContext.displayName ||= 'BaseUrlContext' } catch {}
try{ BaseUrlContextProvider.displayName ||= 'BaseUrlContextProvider' } catch {}